/*
 *
 * Agenda constants
 *
 */

export const FLUSH_STATE = 'app/Agenda/FLUSH_STATE';

export const LOAD_COURSES = 'app/Agenda/LOAD_COURSES';
export const LOAD_COURSES_SUCCESS = 'app/Agenda/LOAD_COURSES_SUCCESS';
export const LOAD_COURSES_ERROR = 'app/Agenda/LOAD_COURSES_ERROR';